import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

/** Small uppercase label with a rose rule, used above section headings. */
const Eyebrow = ({ children, className }: EyebrowProps) => (
  <span className={cn('eyebrow', className)}>{children}</span>
);

export default Eyebrow;
